import * as cornerstone from "@cornerstonejs/core";

export const SHARED_ENGINE_ID = "shared-rendering-engine";

let engineInstance = null;
let refCount = 0;

/**
 * Returns the shared RenderingEngine, creating it on first call.
 * Call releaseRenderingEngine() in each viewer's cleanup to track usage.
 * The engine is only destroyed when all viewers have released it.
 */
export function acquireRenderingEngine() {
  if (!engineInstance) {
    engineInstance = new cornerstone.RenderingEngine(SHARED_ENGINE_ID);
  }
  refCount++;
  return engineInstance;
}

export function releaseRenderingEngine() {
  refCount = Math.max(0, refCount - 1);
  if (refCount === 0 && engineInstance) {
    try {
      engineInstance.destroy();
    } catch (e) {
      console.warn("Error destroying shared rendering engine:", e);
    }
    engineInstance = null;
  }
}

export function getActiveRefCount() {
  return refCount;
}
